import React from 'react'
import OneComponetSC from './OneComponetSC';
export default function Sourcecode(props) {
    window.scrollTo(0, 0);
    const element = props.element;
    return (
        <div className="container my-4">
            <h2><b>{element.component_name}:</b></h2>
            {element.description !== null && (
                <h6>{element.description}</h6>)}
            {element.youtube_short_url !== null && (
                <iframe title={element.component_name} width="100%" style={{ height: "75vh" }} src={element.youtube_short_url}></iframe>
            )}
            {element.fileCode.length > 0 && element.fileCode.map((elements, index) => {
                return (
                    <OneComponetSC fileType={element.fileType[index]} fileName={element.fileName[index]} fileCode={elements} />)
            })}
            <h3>Video:</h3>
            {element.youtube_url === null ? (
                <h5>Coming Soon</h5>
            ) : (
                <iframe title={element.component_name} width="100%" style={{ height: "75vh" }} frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen src={element.youtube_url}></iframe>
            )}


        </div>
    )
}
